import PropTypes from 'prop-types';

import CustomIcon from '../../../CustomIcons';

const CartIcon = ({ cartPageUrl, cartItemCount }) => {
  const location = window.location.pathname;
  const isOrderBuilder = location.includes('orderbuilder');

  const getIcon = () => (
    <>
      <CustomIcon type="shoppingCart" size="24" className="cart-icon" fill="#FFFFFF" />
      {!!cartItemCount && <span className="header__cart-count b">{cartItemCount}</span>}
    </>
  );

  return isOrderBuilder ? (
    <div className="header__cart flex-group">{getIcon()}</div>
  ) : (
    <a href={cartPageUrl} className="header__cart flex-group" aria-label="Go to your cart">
      {getIcon()}
    </a>
  );
};

CartIcon.propTypes = {
  cartPageUrl: PropTypes.string.isRequired,
  cartItemCount: PropTypes.number.isRequired
};

export default CartIcon;
